import ApiClient from 'components/ApiClient'

const client = new ApiClient()
const API_ENDPOINT = __CONFIG__.apiPath.socket

export const register = sid => client.post(API_ENDPOINT.register, { data: { sid } })
